let countries = {
    es: {
        message: [
            {name: 'Argentina', code: 'AR'},
            {name: 'Brasil', code: 'BR'},
            {name: 'Chile', code: 'CL'},
            {name: 'Colombia', code: 'CO'},
            {name: 'Estados Unidos', code: 'US'},
            {name: 'México', code: 'MX'},
            {name: 'Perú', code: 'PE'},
            { name: 'Panamá', code: 'PA' },
            {name: 'España', code: 'ES' },
            
        ],
    },
    en: {
        message: [
            {name: 'Argentina', code: 'AR'},
            {name: 'Brazil', code: 'BR'},
            {name: 'Chile', code: 'CL'},
            {name: 'Colombia', code: 'CO'},
            {name: 'United States', code: 'US'},
            {name: 'Mexico', code: 'MX'},
            {name: 'Peru', code: 'PE'},
            { name: 'Panama', code: 'PA' },
            {name: 'Spain', code: 'ES' },
        ],
    },
    pt_BR: {
        message: [
            {name: 'Argentina', code: 'AR'},
            {name: 'Brasil', code: 'BR'},
            {name: 'Chile', code: 'CL'},
            {name: 'Colômbia', code: 'CO'},
            {name: 'Estados Unidos', code: 'US'},
            {name: 'México', code: 'MX'},
            {name: 'Peru', code: 'PE'},
            { name: 'Panamá', code: 'PA' },
            {name: 'Espanha', code: 'ES' },
            
        ],
    },
};
export {countries};
